export const parseFloatOrNull = (value: string) => {
  const result = parseFloat(value);
  return isNaN(result) ? null : result;
};

export const parseIntOrNull = (value: string) => {
  // eslint-disable-next-line radix -- FIXME
  const result = parseInt(value);
  return isNaN(result) ? null : result;
};
